import { useContext, useRef, useState } from "react";
import BannerAlert from "./BannerAlertCopy";
import CCOffcanvas from "./CCOffcanvas.tsx";
import PageContext from "./PageContext.jsx";
import ArrowUpwardIcon from "../../svgs/uparrow.svg";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ButtonComponent from "./ButtonComponent.jsx";
import { Button, styled } from "@mui/material";
import UploadS3ExcelButton from "./UploadS3ExcelButtonCopy.jsx";
import { HttpContext } from "../../api-services/HttpService.js";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: "1",
});

const StyledButton = styled(Button)({
  backgroundColor: "#185230",
  color: "#FFFFFF",
  borderRadius: "20px",
  padding: "6px 16px",
  textTransform: "none",
  fontWeight: "500",
  fontFamily: "Roboto medium",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "#185230",
  },
});

const AddExcelTemplateModal = () => {
  // get context from parent
  const {
    showUploadExcelTemplateModal,
    setShowUploadExcelTemplateModal,
    templateType,
    snackbarAlert,
    refreshData,
    companyInfo,
  } = useContext(PageContext);

  const { PUT } = useContext(HttpContext);

  const [fileSelected, setFileSelected] = useState(false);
  // initialize refs for file
  const excelFile = useRef();
  const excelFileInput = useRef();
  const [uploadFileName, setUploadFileName] = useState("");

  // handle contract file change
  const onFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFileSelected(true);
    }
    console.log(e);
    // update file ref
    excelFile.current = e.target.files[0];

    // remove (1) from filename
    let name = excelFile.current.name;
    name = name.replace(/\s\(\d+\)/g, "");
    console.log(name);
    // assign to state
    setUploadFileName((filename) => (filename = name));
  };

  const putUploadMetadata = () => {
    return new Promise((resolve, reject) => {
      PUT("/data/uploadMetadata", {
        filename: uploadFileName,
        displayname: uploadFileName,
        mastercompanyid: companyInfo["mastercompanyid"],
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const resetFileInput = () => {
    if (
      excelFileInput.current != null &&
      excelFileInput.current.value != null
    ) {
      excelFileInput.current.value = "";
    }
    if (excelFile.current != null) {
      excelFile.current = null;
    }
    setUploadFileName("");
    setFileSelected(false);
  };

  return (
    <CCOffcanvas
      title={"Upload Excel"}
      show={showUploadExcelTemplateModal}
      onCanvasClose={() =>
        setShowUploadExcelTemplateModal(
          (showUploadExcelTemplateModal) =>
            (showUploadExcelTemplateModal = false)
        )
      }
      bodyCssClassName="offcanvas-body bg-white p-3"
      offCanvasClassName="offcanvas-parent-card-30"
    >
      <div className="d-flex flex-column h-100">
        <div>
          <BannerAlert
            show={true}
            type="info"
            message={
              "When you upload a new " +
              templateType["templatetypedescription"] +
              " template, it overwrites all existing " +
              templateType["templatetypedescription"] +
              " for this master company."
            }
            disableClose={true}
          />
        </div>
        <hr className="m-0 mb-3 mt-2" />
        <div>
          <div className="mb-3">Choose Template File</div>
          <StyledButton
            component="label"
            role={undefined}
            tabIndex={-1}
            endIcon={
              fileSelected ? <CheckIcon /> : <img src={ArrowUpwardIcon} />
            }
          >
            {fileSelected ? "File Selected" : "Browse"}
            <VisuallyHiddenInput
              type="file"
              class="page-file-input"
              accept=".xls,.xlsx"
              onChange={onFileChange}
              ref={(ref) => (excelFileInput.current = ref)}
            />
          </StyledButton>
          <div className="d-flex mt-3">
            {fileSelected && excelFile ? excelFile?.current?.name : null}
            {fileSelected && excelFile ? (
              <CloseIcon
                sx={{ color: "red", width: "18px", marginLeft: "1rem" }}
                onClick={() => {
                  resetFileInput();
                }}
              />
            ) : null}
          </div>
        </div>
        <hr className="m-0 mb-2  mt-2" />
        <div
          className="d-flex justify-content-end p-3 pe-0 w-100 offcanvas-footer z-2"
          style={{ height: "65px" }}
        >
          <ButtonComponent
            tag={"Cancel"}
            border={"#fcd800 1px solid"}
            background={"#fff"}
            color={"#001317"}
            onButtonClick={() =>
              setShowUploadExcelTemplateModal(
                (setShowUploadExcelTemplateModal) =>
                  (setShowUploadExcelTemplateModal = false)
              )
            }
          />
          <UploadS3ExcelButton
            tag="Upload"
            folder="uploads/"
            filename={uploadFileName}
            file={excelFile}
            fileInput={excelFileInput}
            putMetadata={putUploadMetadata}
            refreshData={refreshData}
            snackbarAlert={snackbarAlert}
            validateData={() => {
              return true;
            }}
            css="modal-button-full-blue-upload"
            showSpinner={false}
            resetFileInput={resetFileInput}
          />
        </div>
      </div>
    </CCOffcanvas>
  );
};

export default AddExcelTemplateModal;
